// extracted by mini-css-extract-plugin
export var raceBadge = "QuaddieSelectionCard-module--raceBadge--fbc89";